<template>
  <picture class="inline laptop:m-auto">
    <source media="(min-width:1024px)" srcset="../../assets/img/logo-footer.png" />
    <img src="../../assets/img/logo-small.png" alt="Intercomm Foods Logo" />
  </picture>
</template>
<script setup></script>
<style lang="scss" scoped></style>
